import { collection, addDoc } from 'firebase/firestore';
import { getToken } from 'firebase/messaging';
import { db, messaging } from '../firebase';

export const getFCMRegistrationToken = async (employeeInfo) => {
  try {
    if (!('serviceWorker' in navigator)) {
      console.error('Service Worker not supported in this browser.');
      return;
    }
    const registration = await navigator.serviceWorker.ready;
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration, // Make sure to use the registered SW
    });

    if (currentToken) {
      const tokens = collection(db, 'tokens'); // Reference to the collection
      const result = await addDoc(tokens, {
        source: 'webapp',
        token: currentToken,
        eid: employeeInfo.id,
        createdAt: new Date(),
      }); // Add the token to Firestore

      if (process.env.NODE_ENV === 'development') {
        console.info('Generated token info:', {
          userId: employeeInfo.uid,
          tokenId: result?.id,
          employeeId: employeeInfo.id,
        }); // Debug log for development only
      }
    } else {
      // Show permission request UI
      console.warn('No registration token available. Request permission to generate one.');
    }
  } catch (err) {
    console.error('An error occurred while retrieving token. ', err);
  }
};
